<div class="w-full flex flex-col gap-4 p-4" [formGroup]="form">
    <app-page-header [urlName]="'Cest'" urlPath="cest"></app-page-header>

    <p-card class="md:max-w-250">
        <div class="w-full flex flex-col gap-4">
            <h1 class="text-2xl font-bold">Editar/Incluir Cest</h1>

            <div class="w-full grid sm:grid-cols-12 grid-cols-1 gap-4 items-end">
                <app-input
                    id="descricao"
                    label="Descrição"
                    formControlName="Descricao"
                    class="sm:col-span-10"
                ></app-input>

                <app-input
                    id="segmento"
                    label="Segmento"
                    formControlName="Segmento"
                    class="sm:col-span-2"
                ></app-input>

                <app-input
                    id="itemsegmento"
                    label="Item Segmento"
                    formControlName="ItemSegmento"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="especificacao"
                    label="Especificação"
                    formControlName="Especificacao"
                    class="sm:col-span-4"
                ></app-input>

                <app-input
                    id="codigocest"
                    label="Código Cest"
                    formControlName="CodigoCest"
                    class="sm:col-span-4"
                ></app-input>

                <app-input-icon
                    label="Ncm"
                    formControlName="Ncms"
                    (onBlur)="verificaNcmValido($event)"
                    (onKeypress)="verificaNcmValido($event)"
                    class="sm:col-span-8"
                >
                    <app-button
                        icon="fa fa-search"
                        class="h-full"
                        (click)="modalPesquisaNcm = true"
                    ></app-button>
                </app-input-icon>
            </div>

            <div
                class="w-full flex sm:flex-row flex-col gap-4 justify-end items-end"
            >
                <app-button
                    variant="danger"
                    (click)="cancelar()"
                    class="md:max-w-45 w-full"
                    >Cancelar</app-button
                >

                <app-button
                    variant="success"
                    (click)="processarFormulario()"
                    class="md:max-w-45 w-full"
                    >Salvar</app-button
                >
            </div>
        </div>
    </p-card>
</div>
